import axios, { AxiosResponse } from 'axios';
import { getAccessToken } from './accessToken';
import { URL_LIBRANZAS, LIBRANZAS_APIKEY } from '@/constants/api-constants';

export const setCancelarSesionPlaceToPayLibranzas = (requestId: string): Promise<AxiosResponse | undefined> =>
    getAccessToken()
        .then((tokenResponse) => {
            const token = tokenResponse?.data.data.id_token;
            return axios.request({
                method: 'put',
                url: `${URL_LIBRANZAS}/pagos/cancelar-sesion/${requestId}`,
                headers: {
                    apikey: LIBRANZAS_APIKEY,
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: null,
            });
        })
        .catch((error) => {
            console.error(error);
            return undefined;
        });
